import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { BehaviorSubject, Observable } from "rxjs";

import { ConfigService } from "../../config/config.service";

import { CurrencyConfig } from "./currency.model";

@Injectable({
	providedIn: "root",
})
export class CurrencyConfigService {
	private currencyConfigOverride: CurrencyConfig | undefined;
	private currencyConfigOverrideSubject$$: BehaviorSubject<CurrencyConfig> = new BehaviorSubject<CurrencyConfig>({});

	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	set(config: CurrencyConfig) {
		this.currencyConfigOverride = { ...config };
		this.currencyConfigOverrideSubject$$.next(this.get());
	}

	get(): CurrencyConfig {
		return this.currencyConfigOverride || this.configService.get((x) => x.global.i18n.currency, {});
	}

	get$(): Observable<CurrencyConfig> {
		return this.currencyConfigOverrideSubject$$.asObservable();
	}
}
